// extracted by mini-css-extract-plugin
export var adultsOnly = "HotelCardTopResults-module--adultsOnly--e55cd";
export var buttonsContainer = "HotelCardTopResults-module--buttonsContainer--dd887";
export var contentContainer = "HotelCardTopResults-module--contentContainer--07802";
export var heading = "HotelCardTopResults-module--heading--6b04c";
export var hotelCard = "HotelCardTopResults-module--hotelCard--fe1c4";
export var hotelCardLink = "HotelCardTopResults-module--hotelCardLink--57b5d";
export var image = "HotelCardTopResults-module--image--67394";
export var link = "HotelCardTopResults-module--link--8e012";
export var linkText = "HotelCardTopResults-module--linkText--d997a";
export var ratingsContainer = "HotelCardTopResults-module--ratingsContainer--5fd01";
export var subheading = "HotelCardTopResults-module--subheading--92e5e";